// create a storage service that works with indexeddb and has functions setItem, getItem, removeItem, clear, and getAllItems. The indexed db will be storing data in a json format. But the catch is that the storage itself is mapped to a value called 'workflowId', which is something that will be retrieved from the sessionstorage. retreieve the workflowid for everyoperation

import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class IndexStorageService {

    constructor() { }

    private getWorkflowId(): string | null {
        // return sessionStorage.getItem('candidateWorkflowId');
        let sessionId='';
        // generate a random 16 character alphanumeric string
        if (sessionStorage.getItem('sessionId') === null) {
            sessionId = Math.random().toString(36).substring(2, 18);
            sessionStorage.setItem('sessionId', sessionId);
        } else {
            sessionId = sessionStorage.getItem('sessionId') || '';
        }
        return sessionId;
    }

    private getStoreName(): string {
        const workflowId = this.getWorkflowId();
        return workflowId ? `workflow_${workflowId}` : 'default_workflow';
    }

    private async getDb(): Promise<IDBDatabase> {
        return new Promise((resolve, reject) => {
            const request = indexedDB.open(this.getStoreName(), 1);
            request.onupgradeneeded = (event) => {
                const db = (event.target as IDBOpenDBRequest).result;
                if (!db.objectStoreNames.contains('items')) {
                    db.createObjectStore('items');
                }
            };
            request.onsuccess = () => resolve(request.result);
            request.onerror = () => reject(request.error);
        });
    }

    async setItem(key: string, value: any): Promise<void> {
        // alert('Setting item in IndexDB with key: ' + key );
        const db = await this.getDb();
        // experimental sessionstorage save 
        sessionStorage.setItem(key, value);
        // end experimental sessionstorage save
        return new Promise((resolve, reject) => {
            const transaction = db.transaction('items', 'readwrite');
            const store = transaction.objectStore('items');
            const request = store.put(value, key);
            request.onsuccess = () => resolve();
            request.onerror = () => reject(request.error);
        });
    }

    /**
     * Retrieves an item from IndexedDB (or falls back to sessionStorage) and returns its parsed value.
     */
    async getItem<T = string>(key: string) {
        const db = await this.getDb();
        const transaction = db.transaction('items', 'readonly');
        const store = transaction.objectStore('items');

        // fetch from IndexedDB
        let result = await new Promise<T | undefined>((resolve, reject) => {
            const request = store.get(key);
            request.onsuccess = () => resolve(request.result);
            request.onerror = () => reject(request.error);
        });

        // if not found in IndexedDB, fallback to sessionStorage
        if (result === undefined || result === null) {
            const sessionValue = sessionStorage.getItem(key);
            return sessionValue|| null;
        }
        // result=await result;
        console.log('getItem', key);
        return result as T;
    }

    async removeItem(key: string): Promise<void> {
        const db = await this.getDb();
        return new Promise((resolve, reject) => {
            const transaction = db.transaction('items', 'readwrite');
            const store = transaction.objectStore('items');
            const request = store.delete(key);
            request.onsuccess = () => resolve();
            request.onerror = () => reject(request.error);
        });
    }

    async clear(): Promise<void> {
        const db = await this.getDb();
        return new Promise((resolve, reject) => {
            const transaction = db.transaction('items', 'readwrite');
            const store = transaction.objectStore('items');
            const request = store.clear();
            request.onsuccess = () => resolve();
            request.onerror = () => reject(request.error);
        });
    }

    async getAllItems(): Promise<any[]> {
        const db = await this.getDb();
        return new Promise((resolve, reject) => {
            const transaction = db.transaction('items', 'readonly');
            const store = transaction.objectStore('items');
            const request = store.getAll();
            request.onsuccess = () => resolve(request.result);
            request.onerror = () => reject(request.error);
        });
    }
    async getAllKeys(): Promise<string[]> {
        const db = await this.getDb();
        return new Promise((resolve, reject) => {
            const transaction = db.transaction('items', 'readonly');
            const store = transaction.objectStore('items');
            const request = store.getAllKeys();
            request.onsuccess = () => resolve(request.result as string[]);
            request.onerror = () => reject(request.error);
        });
    }
}